var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusicIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bb5401ac-095e-4236-8977-e52ded774024",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.56 140.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M72.63,123.68A53.45,53.45,0,1,1,110.46,108,53.21,53.21,0,0,1,72.63,123.68Z",
    style: {
      fill: "#695f69"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.46,108A53.4,53.4,0,0,0,72.63,16.88v106.8A53.19,53.19,0,0,0,110.46,108Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.63,92.11A21.83,21.83,0,1,1,94.49,70.28,21.87,21.87,0,0,1,72.63,92.11Z",
    style: {
      fill: "#e8907a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.49,70.28A21.88,21.88,0,0,0,72.63,48.45V92.11A21.87,21.87,0,0,0,94.49,70.28Z",
    style: {
      fill: "#eccdc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.63,73.42a3.14,3.14,0,0,1-3.14-3.14,3.2,3.2,0,0,1,.92-2.22,3.14,3.14,0,1,1,2.22,5.36Z",
    style: {
      fill: "#59505a"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3,103.87a3.12,3.12,0,0,1-1.85-.6A40.77,40.77,0,0,1,32.38,77.91a3.14,3.14,0,1,1,6.16-1.17A34.54,34.54,0,0,0,52.15,98.21a3.13,3.13,0,0,1-1.85,5.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.79,66.38a3.14,3.14,0,0,1-3.08-2.55A34.53,34.53,0,0,0,93.1,42.35a3.13,3.13,0,1,1,3.7-5.05,40.75,40.75,0,0,1,16.07,25.36,3.12,3.12,0,0,1-2.49,3.66,3,3,0,0,1-.59.06Z",
    style: {
      fill: "#695f69"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/music-icon.536bcb0f2d614c789b97de18fd0d5651.svg";
export { ForwardRef as ReactComponent };